<template>
  <div class="item">
    <div class="item-title">
      <span>{{ value.name }}</span>
      <span v-if="value.total - 1 > 0">{{ $t('common.other') }}{{ value.total - 1 }}{{ $t('common.person') }}</span>
      <span>{{ $t('appointment.visitors.record.other.person') }}</span>
    </div>
    <div class="item-main">
      <div class="item-left">
        <div class="image-container">
          <img :src="url[+value.status + 2]" alt />
        </div>
      </div>
      <div class="item-right">
        <span class="item-right-label">
          <span>{{ $t('appointment.visitors.record.apply.number') }}</span>
          <p class="item-right-text">{{ value.orderNo ? value.orderNo : $t('common.empty') }}</p>
        </span>
        <span class="item-right-label">
          <span>{{ $t('appointment.visitors.record.apply.time') }}</span>
          <p class="item-right-text">
            {{ value.created ? moment(value.created).format('YYYY-MM-DD HH:mm') : $t('common.empty') }}
          </p>
        </span>
        <span class="item-right-label">
          <span>{{ $t('appointment.visiting.time') }}</span>
          <div class="item-right-text">
            <p>
              {{ $t('common.from')
              }}{{ value.begin ? moment(value.begin).format('YYYY-MM-DD HH:mm') : $t('common.empty') }}
            </p>
            <p style="margin-top: 8px">
              {{ $t('common.to') }}{{ value.end ? moment(value.end).format('YYYY-MM-DD HH:mm') : $t('common.empty') }}
            </p>
          </div>
        </span>
        <span class="item-right-label">
          <span>{{ $t('appointment.visitors.record.status') }}</span>
          <p class="item-right-text">{{ $t(`appointment.visitors.review${+value.status + 2}`) }}</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: ['value'],
  data() {
    return {
      url: [
        '/img/picture/wait.png',
        '/img/picture/refuse.png',
        '/img/picture/unvisit.png',
        '/img/picture/agree.png',
        '/img/picture/pass.png',
      ],
      moment,
    };
  },
  methods: {},
  created() {},
};
</script>

<style lang="less" scoped>
.item {
  // min-height: 356px;
  padding: 24px 0;
  margin-top: 1px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  .item-title {
    display: flex;
    padding-left: 30px;
    span {
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #3d424d;
      letter-spacing: 0;
      font-weight: 600;
    }
  }
  .item-main {
    display: flex;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    .item-left {
      flex: 0 0 156px;
      display: flex;
      align-items: stretch;
      justify-content: center;
      .image-container {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      img {
        width: 96px;
      }
    }
    .item-right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: auto;
      .item-right-label {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 16px;
        line-height: 38px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        span {
          font-size: 28px;
          color: #949aa4;
          letter-spacing: 0;
          margin-right: 12px;
          flex: 0 0 140px;
        }
        .item-right-text {
          // font-family: PingFangSC-Regular;
          font-size: 28px;
          color: #5d6067;
          letter-spacing: 0;
          text-align: left;
          word-break: break-all;
        }
      }
      .item-right-label:first-child {
        margin-top: 24px;
      }
    }
  }
}
</style>
